import { DatePicker, Form, Input, Row, Col } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import moment from "moment";

const PaymentBankFields = ({
  handleSubmit,
  formKey,
  state,
  handleDatepickerChange,
  handlePaymentChange,
  updateBankFieldsValidity,
}) => {
  const { t } = useTranslation();
  const formRef = useRef(null);

  useEffect(() => {
    validateFields();
    formRef.current.setFieldsValue({
      bank_garrentee_open_date:
        state.company_payment_terms[0].bank_garrentee_open_date === null
          ? null
          : moment(
              state.company_payment_terms[0].bank_garrentee_open_date,
              "DD-MM-YY"
            ),
      bank_garrentee_validity_complation_date:
        state.company_payment_terms[0]
          .bank_garrentee_validity_complation_date === null
          ? null
          : moment(
              state.company_payment_terms[0]
                .bank_garrentee_validity_complation_date,
              "DD-MM-YY"
            ),
      bank_garrentee_value:
        state.company_payment_terms[0].bank_garrentee_value === null
          ? null
          : state.company_payment_terms[0].bank_garrentee_value,
      bank_guarantee_supply_limit_value:
        state.company_payment_terms[0].bank_guarantee_supply_limit_value ===
        null
          ? null
          : state.company_payment_terms[0].bank_guarantee_supply_limit_value,
    });
  }, [state]);

  const validateFields = () => {
    const isBankFieldsFilled =
      state.company_payment_terms[0].bank_garrentee_value &&
      state.company_payment_terms[0].bank_guarantee_supply_limit_value &&
      state.company_payment_terms[0].bank_garrentee_open_date &&
      state.company_payment_terms[0].bank_garrentee_validity_complation_date;

    updateBankFieldsValidity(isBankFieldsFilled);
  };

  return (
    <div>
      {" "}
      <>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          key={formKey}
          ref={formRef}
        >
          <Row gutter={[15]}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("pl_bank_garrentee_value")}
                name="bank_garrentee_value"
                key={formKey}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_bank_garrentee_value")}</Trans>,
                  },
                ]}
              >
                <Input
                  type="number"
                  addonBefore="₹"
                  placeholder={t("pl_bank_garrentee_value")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); 
                    }
                  }}
                  onChange={(e) =>
                    handlePaymentChange(
                      "bank_garrentee_value",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("pl_bank_guarantee_supply_limit_value")}
                key={formKey}
                name="bank_guarantee_supply_limit_value"
                rules={[
                  {
                    required: true,
                    message: (
                      <Trans>
                        {t("val_bank_guarantee_supply_limit_value")}
                      </Trans>
                    ),
                  },
                ]}
              >
                <Input
                  type="number"
                  addonBefore="₹"
                  placeholder={t("pl_bank_guarantee_supply_limit_value")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); 
                    }
                  }}
                  onChange={(e) =>
                    handlePaymentChange(
                      "bank_guarantee_supply_limit_value",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="bank_garrentee_open_date"
                label={t("pl_bank_garrentee_open_date")}
                key={formKey}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_postal_open_date")}</Trans>,
                  },
                ]}
              >
                <DatePicker
                  format={"DD-MM-YY"}
                  onChange={(date, dateString) =>
                    handleDatepickerChange(
                      date,
                      dateString,
                      "bank_garrentee_open_date"
                    )
                  }
                  value={
                    state.company_payment_terms[0].bank_garrentee_open_date
                      ? moment(
                          state.company_payment_terms[0]
                            .bank_garrentee_open_date,
                          "DD-MM-YY"
                        )
                      : null
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="bank_garrentee_validity_complation_date"
                label={t("pl_bank_garrentee_validity_complation_date")}
                key={formKey}
                rules={[
                  {
                    required: true,
                    message: (
                      <Trans>{t("val_postal_validity_complation")}</Trans>
                    ),
                  },
                ]}
              >
                <DatePicker
                  format={"DD-MM-YY"}
                  onChange={(date, dateString) =>
                    handleDatepickerChange(
                      date,
                      dateString,
                      "bank_garrentee_validity_complation_date"
                    )
                  }
                  
                  value={
                    state.company_payment_terms[0]
                      .bank_garrentee_validity_complation_date
                      ? moment(
                          state.company_payment_terms[0]
                            .bank_garrentee_validity_complation_date,
                          "DD-MM-YY"
                        )
                      : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    </div>
  );
};
PaymentBankFields.propTypes = {
  handleSubmit: PropTypes.func,
  formKey: PropTypes.number,
  state: PropTypes.func,
  handleDatepickerChange: PropTypes.func,
  handlePaymentChange: PropTypes.func,
  setPaymentBankEditFlag: PropTypes.func,
  updateBankFieldsValidity: PropTypes.func,
};
export default PaymentBankFields;
